(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Blog-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript && document.currentScript.closest('section[data-section-type="blog-slider"]');
  if(!root){
    var nodes = document.querySelectorAll('section[data-section-type="blog-slider"][data-wired="false"]');
    root = nodes[nodes.length - 1] || null;
  }
  if(!root || root.getAttribute('data-wired') === 'true') return;
  root.setAttribute('data-wired','true');

  var track    = root.querySelector('[data-track]');
  var prevBtn  = root.querySelector('[data-prev]');
  var nextBtn  = root.querySelector('[data-next]');
  var dotsWrap = root.querySelector('[data-dots]');
  var dots     = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-dot]')) : [];
  if(!track) return;

  var slides   = Array.prototype.slice.call(track.querySelectorAll('.blog-slider__slide'));
  var loop     = track.getAttribute('data-loop') === 'true';
  var autoplay = track.getAttribute('data-autoplay') === 'true';
  var interval = parseInt(track.getAttribute('data-interval'), 10) || 5000;
  var reduce   = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) autoplay = false;

  var index = 0, timer = null;
  function gap(){ return parseFloat(getComputedStyle(track).getPropertyValue('--gap')) || 0; }
  function slideW(){ var s = slides[0]; return s ? s.getBoundingClientRect().width + gap() : 0; }
  function clamp(i){ return loop ? (i<0?slides.length-1:i>=slides.length?0:i) : Math.max(0, Math.min(i, slides.length-1)); }

  function goTo(i, instant){
    index = clamp(i);
    var x = Math.round(index * slideW());
    track.scrollTo({ left: x, behavior: instant ? 'auto' : 'smooth' });
    updateUI();
  }

  function updateIndexFromScroll(){
    var w = slideW();
    if(!w) return;
    var i = Math.round(track.scrollLeft / w);
    if(i !== index){ index = clamp(i); updateUI(); }
  }

  function updateUI(){
    if(prevBtn) prevBtn.disabled = !loop && index === 0;
    if(nextBtn) nextBtn.disabled = !loop && index === slides.length - 1;
    if(dotsWrap){
      if(!dots.length) dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-dot]'));
      dots.forEach(function(d,di){ d.setAttribute('aria-selected', di === index ? 'true' : 'false'); });
    }
  }

  function onPrev(e){ if(e) e.preventDefault(); goTo(index - 1); }
  function onNext(e){ if(e) e.preventDefault(); goTo(index + 1); }
  function startAutoplay(){ if(!autoplay || timer) return; timer = setInterval(function(){ goTo(index + 1); }, interval); }
  function stopAutoplay(){ if(timer){ clearInterval(timer); timer = null; } }

  if(prevBtn) prevBtn.addEventListener('click', onPrev);
  if(nextBtn) nextBtn.addEventListener('click', onNext);
  if(dotsWrap){
    dotsWrap.addEventListener('click', function(e){
      var t = e.target.closest('[data-dot]');
      if(!t) return;
      e.preventDefault();
      var di = parseInt(t.getAttribute('data-dot'),10) || 0;
      goTo(di);
    });
  }

  track.addEventListener('scroll', function(){ window.requestAnimationFrame(updateIndexFromScroll); });
  track.addEventListener('keydown', function(e){
    if(e.key === 'ArrowRight'){ e.preventDefault(); onNext(); }
    if(e.key === 'ArrowLeft'){  e.preventDefault(); onPrev(); }
    if(e.key === 'Home'){       e.preventDefault(); goTo(0); }
    if(e.key === 'End'){        e.preventDefault(); goTo(slides.length - 1); }
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);
  root.addEventListener('focusin', stopAutoplay);
  root.addEventListener('focusout', startAutoplay);
  window.addEventListener('resize', function(){ updateIndexFromScroll(); });

  updateUI();
  startAutoplay();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SBP-Product-Core"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript.closest('.dds-pv3') || document.querySelector('.dds-pv3');
  if (!root) return;

  var dataEl = root.querySelector('.dds-data'); if (!dataEl) return;
  var data; try{ data = JSON.parse(dataEl.textContent); }catch(e){ return; }

  var variants = Array.isArray(data.variants) ? data.variants : [];
  var moneyFormat = data.moneyFormat ? String(data.moneyFormat) : ('{' + '{amount' + '}}');

  // Thumbnails
  root.querySelectorAll('.thumb').forEach(function(btn){
    btn.addEventListener('click', function(){
      root.querySelectorAll('.thumb').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var img = root.querySelector('.hero');
      if (img){ img.src = btn.getAttribute('data-src'); img.srcset = btn.getAttribute('data-srcset'); }
    });
  });

  // Quantity
  var qty = root.querySelector('.qty-input');
  root.querySelectorAll('.qty-btn').forEach(function(b){
    b.addEventListener('click', function(){
      if (!qty) return;
      var n = parseInt(qty.value || '1', 10);
      var d = parseInt(b.getAttribute('data-qty'), 10);
      qty.value = Math.max(1, n + d);
    });
  });

  // Variants
  var form = root.querySelector('form.product-form');
  function updateVariant(){
    var selected = [];
    root.querySelectorAll('.opt-select').forEach(function(s){
      selected[parseInt(s.getAttribute('data-opt-position'),10)-1] = s.value;
    });
    root.querySelectorAll('.chip.is-active').forEach(function(b){
      selected[parseInt(b.getAttribute('data-opt-position'),10)-1] = b.getAttribute('data-opt-value');
    });
    var match = variants.find(function(v){
      return v.options && v.options.every(function(val,i){ return !selected[i] || val === selected[i]; });
    });
    if (!match) return;
    var idEl = form && form.querySelector('input[name="id"]'); if (idEl) idEl.value = match.id;
    var priceEl = root.querySelector('.price-row .current');
    if (priceEl && window.Shopify && typeof Shopify.formatMoney === 'function'){
      priceEl.textContent = Shopify.formatMoney(match.price, moneyFormat);
      priceEl.setAttribute('content', (match.price/100).toFixed(2));
    }
  }
  root.querySelectorAll('.opt-select').forEach(function(s){ s.addEventListener('change', updateVariant); });
  root.querySelectorAll('.chip').forEach(function(b){
    b.addEventListener('click', function(){
      var pos = b.getAttribute('data-opt-position');
      root.querySelectorAll('.chip[data-opt-position="'+pos+'"]').forEach(function(x){ x.classList.remove('is-active'); });
      b.classList.add('is-active');
      updateVariant();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coll-kit-halloween-eeat-2025"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('[data-coll-eeat]');
  if(!roots.length) return;
  roots.forEach(function(root){
    var faq = root.querySelector('[data-accordion]');
    if(!faq) return;
    faq.addEventListener('click', function(e){
      var btn = e.target.closest('.faq__summary');
      if(!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if(panel){
        panel.hidden = expanded;
        var live = document.getElementById(root.getAttribute('data-live'));
        if(live){ live.textContent = (expanded ? 'Collapsed: ' : 'Expanded: ') + btn.querySelector('.faq__q').textContent; }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-promo"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  
  class FlashSaleTimer {
    constructor(element) {
      if (!element) return;
      
      this.element = element;
      this.display = element.querySelector('.fs__timer-display');
      
      if (!this.display) {
        console.warn('Flash Sale: Timer display element not found');
        return;
      }
      
      this.endTime = new Date(element.dataset.end);
      this.format = element.dataset.format || 'hms';
      this.expiredMsg = element.dataset.expiredMsg || 'Offer expired';
      this.respectReducedMotion = element.dataset.respectReducedMotion === 'true';
      this.intervalId = null;
      this.prefersReducedMotion = false;
      
      this.init();
    }
    
    init() {
      // Check if date is valid
      if (isNaN(this.endTime.getTime())) {
        console.error('Flash Sale: Invalid end date');
        this.display.innerHTML = '<span class="fs__timer-expired">Invalid date</span>';
        return;
      }
      
      // Check reduced motion preference if enabled
      if (this.respectReducedMotion) {
        this.checkReducedMotion();
      }
      
      // Clear loading state
      this.display.innerHTML = '';
      
      // Start the timer
      this.update();
      this.start();
      
      // Mark section as loaded
      const section = this.element.closest('.fs');
      if (section) {
        section.classList.add('fs--loaded');
      }
      
      // Listen for visibility changes to optimize performance
      this.handleVisibilityChange();
    }
    
    checkReducedMotion() {
      try {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.prefersReducedMotion = mediaQuery.matches;
        
        mediaQuery.addEventListener('change', (e) => {
          this.prefersReducedMotion = e.matches;
          this.restart();
        });
      } catch (e) {
        console.warn('Flash Sale: Could not detect motion preference', e);
      }
    }
    
    handleVisibilityChange() {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.update();
          this.start();
        }
      });
    }
    
    formatTime(totalSeconds) {
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      const pad = (n) => String(n).padStart(2, '0');
      
      switch (this.format) {
        case 'dhms':
          if (days > 0) {
            return `${days}d ${pad(hours)}h ${pad(minutes)}m`;
          }
          return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          
        case 'hm':
          return `${pad(hours)}:${pad(minutes)}`;
          
        case 'hms':
        default:
          return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
    }
    
    update() {
      const now = new Date();
      const diff = Math.max(0, this.endTime - now);
      
      if (diff <= 0) {
        this.display.innerHTML = `<span class="fs__timer-expired">${this.expiredMsg}</span>`;
        this.element.setAttribute('aria-label', this.expiredMsg);
        this.stop();
        this.onExpire();
        return;
      }
      
      const seconds = Math.floor(diff / 1000);
      this.display.textContent = this.formatTime(seconds);
      
      // Update ARIA label for screen readers every minute
      if (seconds % 60 === 0) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        let ariaLabel = 'Time remaining: ';
        
        if (hours > 0) {
          ariaLabel += `${hours} hour${hours !== 1 ? 's' : ''} `;
        }
        if (minutes > 0 || hours === 0) {
          ariaLabel += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
        }
        
        this.element.setAttribute('aria-label', ariaLabel);
      }
    }
    
    start() {
      // Use longer interval if reduced motion is preferred (when respect setting is enabled)
      const interval = (this.respectReducedMotion && this.prefersReducedMotion) ? 5000 : 1000;
      this.intervalId = setInterval(() => this.update(), interval);
    }
    
    stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
    
    restart() {
      this.stop();
      this.update();
      this.start();
    }
    
    onExpire() {
      // Dispatch custom event
      const event = new CustomEvent('flashsale:expired', {
        detail: { timer: this },
        bubbles: true
      });
      this.element.dispatchEvent(event);
      
      // Update CTA button states
      const section = this.element.closest('.fs');
      if (section) {
        const ctas = section.querySelectorAll('.fs__cta');
        ctas.forEach(cta => {
          cta.setAttribute('aria-disabled', 'true');
          cta.setAttribute('tabindex', '-1');
        });
      }
    }
  }
  
  // Initialize all timers on the page
  function initTimers() {
    try {
      const timers = document.querySelectorAll('.fs__timer[data-end]');
      timers.forEach(timer => new FlashSaleTimer(timer));
    } catch (e) {
      console.error('Flash Sale: Error initializing timers', e);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimers);
  } else {
    initTimers();
  }
  
  // Reinitialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    const timer = section.querySelector('.fs__timer[data-end]');
    if (timer) {
      new FlashSaleTimer(timer);
    }
  });
  
  // Expose class for external use if needed
  window.FlashSaleTimer = FlashSaleTimer;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
